/**
* Generated by scripts/generate-declared-statuses.mjs from apps/ligretto-core-backend/openapi.json and openapi.internal.json.
* Do not edit manually.
*/

/**
 * The statuses each operation of both documents declares, keyed `'<METHOD> <path template>'` as a generated operation
 * passes them to the transport. An answer with a status missing here is outside the contract.
 */
export const declaredStatuses: Readonly<Record<string, readonly number[] | undefined>> = {
  'GET /api/auth/callback': [302, 400, 429, 503],
  'GET /api/auth/logout': [200, 302, 503],
  'GET /api/auth/me': [200, 429, 503],
  'GET /api/auth/sign-in': [200, 302, 429, 503],
  'GET /api/users': [200, 400, 401, 503],
  'GET /health': [200, 503],
  'GET /internal/games/{id}/results': [200, 400, 401, 404],
  'POST /internal/games': [201, 401],
  'POST /internal/games/{id}/rounds': [200, 400, 401, 404, 409, 422],
}
